import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ToolbarState {
  fonts: {
    text: string;
    title: string;
    size: number;
    headingSize: number;
  };
  paragraph: {
    number: boolean;
    lineHeight: number;
  };
  reference: {
    refStyle: string;
    refDisplay: string;
  };
  connectedUsers: any;
}

const initialState: ToolbarState = {
  fonts: { text: "Lato", title: "Raleway", size: 11, headingSize: 27 },
  paragraph: { number: true, lineHeight: 1.5 },
  reference: { refStyle: "", refDisplay: "" },
  connectedUsers: [],
};

const toolbarSlice = createSlice({
  name: "toolbar",
  initialState,
  reducers: {
    toolbarSetConnectedUsers: (state, action) => {
      state.connectedUsers = action.payload;
    },
    toolbarSetTextFont: (state, action: PayloadAction<string>) => {
      state.fonts.text = action.payload;
    },
    toolbarSetTextSize: (state, action: PayloadAction<number>) => {
      state.fonts.size = action.payload;
    },
    toolbarSetHeadingSize: (state, action: PayloadAction<number>) => {
      state.fonts.headingSize = action.payload;
    },
    toolbarSetTitleFont: (state, action: PayloadAction<string>) => {
      state.fonts.title = action.payload;
    },
    toolbarSetParagraphLineHeight: (state, action: PayloadAction<number>) => {
      state.paragraph.lineHeight = action.payload;
    },
    toolbarShowParagraphNumber: (state, action: PayloadAction<boolean>) => {
      state.paragraph.number = action.payload;
    },
    toolbarSetRefDisplay: (state, action: PayloadAction<string>) => {
      state.reference.refDisplay = action.payload;
    },
    toolbarSetRefStyle: (state, action: PayloadAction<string>) => {
      state.reference.refStyle = action.payload;
    },
  },
});

export const {
  toolbarSetParagraphLineHeight,
  toolbarSetTextFont,
  toolbarSetTextSize,
  toolbarSetHeadingSize,
  toolbarSetTitleFont,
  toolbarShowParagraphNumber,
  toolbarSetConnectedUsers,
  toolbarSetRefDisplay,
  toolbarSetRefStyle,
} = toolbarSlice.actions;

export default toolbarSlice.reducer;
